import { Button, Icon } from "@legal-500/legal500-design-system";
import modalStyles from "./LinkContactModal.module.css";
import styles from "./LinkContactConfirm.module.css";

type Props = {
  lawyerName: string;
  contactName: string;
  companyName: string | null;
  linking: boolean;
  error: string | null;
  onBack: () => void;
  onConfirm: () => void;
};

export function LinkContactConfirm({
  lawyerName,
  contactName,
  companyName,
  linking,
  error,
  onBack,
  onConfirm,
}: Props) {
  return (
    <div className={modalStyles.body}>
      <div role="alert" className={styles.callout}>
        <div className={styles.headingRow}>
          <span className={styles.icon} aria-hidden="true">
            <Icon icon="exclamation" size="small" />
          </span>
          <h3 className={styles.heading}>Contact name differs from the referee&apos;s</h3>
        </div>

        <p className={styles.text}>
          The referee named <strong>{lawyerName}</strong>. You are linking this testimonial to{" "}
          <strong>{contactName}</strong>
          {companyName ? ` (${companyName})` : ""}.
        </p>
        <p className={styles.text}>
          The lawyer name will be updated to <strong>{contactName}</strong>.
        </p>
        <p className={styles.question}>Do you want to continue?</p>
      </div>

      {error && <p className={modalStyles.error}>{error}</p>}

      <div className={styles.footer}>
        <Button variant="outlined" color="default" onClick={onBack} disabled={linking}>
          Back
        </Button>
        <Button variant="contained" color="warning" onClick={onConfirm} disabled={linking}>
          {linking ? "Linking..." : "Link anyway"}
        </Button>
      </div>
    </div>
  );
}
